import {
  GET_COUNTRIES,
  GET_COUNTRIES_SUCCESS,
  GET_COUNTRIES_FAILED,
  GET_STATES,
  GET_STATES_SUCCESS,
  GET_STATES_FAILED,
  GET_CITIES,
  GET_CITIES_SUCCESS,
  GET_CITIES_FAILED,
  GET_CITIES_BY_STATE_ID,
  GET_CITIES_BY_STATE_ID_SUCCESS,
  GET_CITIES_BY_STATE_ID_FAILED,
} from './constants';

const getCountries = () => ({
  type: GET_COUNTRIES,
});

const getCountriesSuccess = (countries) => ({
  type: GET_COUNTRIES_SUCCESS,
  payload: { countries },
});

const getCountriesFailed = (error) => ({
  type: GET_COUNTRIES_FAILED,
  payload: { error },
});

const getStates = () => ({
  type: GET_STATES,
});

const getStatesSuccess = (states) => ({
  type: GET_STATES_SUCCESS,
  payload: { states },
});

const getStatesFailed = (error) => ({
  type: GET_STATES_FAILED,
  payload: { error },
});

const getCities = () => ({
  type: GET_CITIES,
});

const getCitiesSuccess = (cities) => ({
  type: GET_CITIES_SUCCESS,
  payload: { cities },
});

const getCitiesFailed = (error) => ({
  type: GET_CITIES_FAILED,
  payload: { error },
});

const getCitiesByStateID = (stateId) => ({
  type: GET_CITIES_BY_STATE_ID,
  payload: { stateId },
});

const getCitiesByStateIdSuccess = (cities) => ({
  type: GET_CITIES_BY_STATE_ID_SUCCESS,
  payload: { cities },
});

const getCitiesByStateIdFailed = (error) => ({
  type: GET_CITIES_BY_STATE_ID_FAILED,
  payload: { error },
});

export {
  getCountries,
  getCountriesSuccess,
  getCountriesFailed,
  getStates,
  getStatesSuccess,
  getStatesFailed,
  getCities,
  getCitiesSuccess,
  getCitiesFailed,
  getCitiesByStateID,
  getCitiesByStateIdSuccess,
  getCitiesByStateIdFailed,
};
